import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import './archive-groups.css';

import UniversalModall, { useModal } from '../../../../../../components/AlertModal/UniversalModal';



const ArchiveGroupsTabs = ({ 
  periods, 
  onCloseArchive,
  onChange,
  children,
  isEmpty,
  showButton = false,
  textButton = '',
  onClick
}) => {
  const [activePeriod, setActivePeriod] = useState(periods[0]?.value || '');



  const {
      modalProps,
      alert,
      confirm,
      prompt,
      success,
      error,
      warning,
      Modal
  } = useModal();


  const handleConfirm = async () => {
      const result = await confirm('Всі місця у всіх групах будуть обнулені.');

      if (result.button === 'Підтвердити') {
          onClick();
      } else {
      console.log('Користувач скасував дію');
      }
  };
  
  
  
    const handleSchoolSelect = (kgId) => {
  
      handleConfirm(kgId);
      
    };

  // Форматируем период для отображения (2024 -> 2024-2025)
  const formatPeriodDisplay = (period) => {
    if (period.includes('-')) return period;
    const year = parseInt(period);
    return `${year}-${year + 1}`;
  };

  

  // Сортируем периоды в обратном порядке (новые сначала)
  const sortedPeriods = useMemo(() => {
    return [...periods].sort((a, b) => {
      const yearA = parseInt(a.value);
      const yearB = parseInt(b.value);
      return yearB - yearA;
    });
  }, [periods]);


  const onChange_ = (value)=>{
    setActivePeriod(value)

    if(onChange){
        onChange(value);
    }
  }


  return (
    <div className="archive-groups-container">
      <div className="periods-tabs mb-4">
        <ul className="nav nav-tabs">
            <li key="tab_name_" className="nav-item"><span className="queuetable-label text-muted">навчальний рік</span></li>
          {sortedPeriods.map((period) => (
            <li key={period.value} className="nav-item">
              <button
                className={`nav-link ${activePeriod === period.value ? 'active' : ''}`}
                onClick={() => onChange_(period.value)}
              >
                <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                {formatPeriodDisplay(period.value)}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Список групп для выбранного периода */}
      <div className="groups-list">        
        {children}
        {isEmpty && (
          <div className="text-center py-5">
            <FontAwesomeIcon icon={faArchive} size="3x" className="text-muted mb-3" />
            <p className="text-muted">Немає груп для обраного періоду</p>
          </div>
        )}
      </div>

      {/* Кнопка закрытия */}
      {showButton && <div className="text-end mt-4">
        <button 
          className="btn btn-secondary"
          onClick={handleConfirm}
        >
          {textButton}
        </button>
      </div>}
      <Modal />
    </div>
  );
};

// Пропсы по умолчанию
ArchiveGroupsTabs.defaultProps = {
  periods: [],
  groupsData: [],
  onCloseArchive: () => {}
};

export default ArchiveGroupsTabs;